export class Actions {
  static Item_Name = 'ITEM:NAME';
  static Item_Tag = 'ITEM:TAG';
  static Item_Split = 'ITEM:SPLIT';
  static Item_Sku = 'ITEM:SKU';
  static Action_SaveForLater = 'ACTION:SAVEFORLATER';
  static Actions_DontImport = 'ACTION:DONTIMPORT';
  static Extra_Sms = 'EXTRA:SMS';
  static Extra_Cover = 'EXTRA:COVER';
  static Extra_PrintInStore = 'EXTRA:PRINTINSTORE';
  static Extra_ExtendedBaseCover = 'EXTRA:EXTENDEDBASECOVER';
  static Extra_DeliveryGuarantee = 'EXTRA:DELIVERYGUARANTEE';
  static Extra_Signature = 'EXTRA:SIGNATURE';
  static Item_Value = 'ITEM:VALUE';
  static Item_Package = 'ITEM:PACKAGE';
  static Item_Quantity = 'ITEM:QUANTITY';
  static Item_Weight = 'ITEM:WEIGHT';
  static Item_Height = 'ITEM:HEIGHT';
  static Item_Length = 'ITEM:LENGTH';
  static Item_Width = 'ITEM:WIDTH';
  static Item_Service = 'ITEM:SERVICE';
  static Item_CourierService = 'ITEM:COURIERSERVICE';
  static Item_TariffCode = 'ITEM:TARIFFCODE';
  static Recipient_Country = 'RECIPIENT:COUNTRY';
  static Recipient_Email = 'RECIPIENT:EMAIL';
  static Recipient_Phone = 'RECIPIENT:PHONE';
  static Label_Reference = 'LABEL:REFERENCE';
  static Label_ReferenceValue = 'LABEL:REFERENCEVALUE';
}
